import React from 'react';
import { SparklesIcon, ChevronRightIcon } from 'lucide-react';
import { PageHeader } from '../components/common/PageHeader';
const reports = [{
  id: '1',
  title: '硕士 · 计算机 · 2026秋',
  date: '2026-05-03',
  schools: ['帝国理工学院', '伦敦大学学院', '新加坡国立大学']
}];
export function MyReports() {
  return <div className="bg-slate-50 min-h-screen pb-10" data-id="element-564">
      <PageHeader title="我的 AI 报告" data-id="element-565" />
      <div className="p-3 space-y-3" data-id="element-566">
        {reports.map(r => <div key={r.id} className="bg-white rounded-2xl p-4" data-id="element-567">
            <div className="flex items-center justify-between mb-2" data-id="element-568">
              <div className="flex items-center gap-1.5 text-blue-600 font-bold text-sm" data-id="element-569">
                <SparklesIcon size={16} data-id="element-570" /> {r.title}
              </div>
              <div className="text-xs text-slate-400" data-id="element-571">{r.date}</div>
            </div>
            <div className="text-xs text-slate-600 mb-3" data-id="element-572">
              匹配院校：{r.schools.join('、')} 等 8 所
            </div>
            <button className="w-full py-2 bg-blue-50 text-blue-600 rounded-xl text-sm font-semibold flex items-center justify-center gap-1" data-id="element-573">
              查看完整报告 <ChevronRightIcon size={14} data-id="element-574" />
            </button>
          </div>)}
      </div>
    </div>;
}